import { TunerVarsActions } from '../constants/TunerVarStateKeys';

export function clearOnDemandArtistMessageData() {
  return {
    type: TunerVarsActions.CLEAR_ON_DEMAND_ARTIST_MESSAGE_DATA,
  };
}
